import { useDispatch, useSelector } from 'react-redux'
import { State } from '../../../../reducers'
import { FACTURACION_TYPES } from '../../../../constants/facturacion.types'
import ObservacionesDocumentoBase from '../../../../components/ObservacionesDocumento/ObservacionesDocumento'

export default function ObservacionesDocumento() {
  const dispatch = useDispatch()
  const { formObservaciones } = useSelector((state: State) => state.facturacion)

  const handleChange = (field: string, value: string | boolean) => {
    dispatch({ type: FACTURACION_TYPES.FORMOBSERVACIONES_HANDLE_CHANGE, payload: { [field]: value } })
  }

  return <ObservacionesDocumentoBase formObservaciones={formObservaciones} onChange={handleChange} />
}
